import { Component, OnInit, EventEmitter } from '@angular/core';
import { NgForm } from '@angular/forms';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { fdsRecipients, fdsServiceAgreementAddModel, fdsServiceDocuments, ServiceAgreementAddModel, fdsServiceDocumentsAdd, fdsOldRecipients, fdsServiceOldDocuments } from 'src/app/shared/models/service-agreement.model';
import { FileUploadAddModel } from 'src/app/shared/models/file-upload.model';
import { ToastrService } from 'ngx-toastr';
import { Utility } from 'src/app/utility/utility';
import { FileUploadResponse, ServiceAgreementResponseProfile, UserGroupResponse } from 'src/app/shared/models/response.model';
import { FileUploadService } from '../../file-upload/file-upload.service';
import { ServiceAgreementService } from 'src/app/service-agreement/service-agreement.service';
import { CookieService } from 'ngx-cookie-service';
import { HttpErrorResponse } from '@angular/common/http';
import { UserGroupAddModel } from 'src/app/shared/models/user-group.model';
import moment from 'moment';

@Component({
  selector: 'app-new-service-agreement',
  templateUrl: './new-service-agreement.component.html',
  styleUrls: ['./new-service-agreement.component.css']
})
export class NewServiceAgreementComponent implements OnInit {

  Isvalid:boolean;
  IsvalidDocument:boolean = true;
  IsvalidRecipient:boolean = true;
  acceptDocType : string;
  serviceAgreementModel : ServiceAgreementAddModel ;
  errors;
  fileUploadAddModel : FileUploadAddModel;
  docUploadSuccess: boolean = false;
  documentLabel = "Choose file";
  minDate = undefined;
  event: EventEmitter<any> = new EventEmitter();
  companyCode:any;
  templateList :any;
  fdsServiceAgreementAddModel: fdsServiceAgreementAddModel;
  fdsServiceDocuments: fdsServiceDocuments;
  fdsServiceDocumentsAdd: fdsServiceDocumentsAdd;
  fdsRecipients: fdsRecipients;
  fileSize: any = "";
  fileData: any = "";
  documentsArray: any;
  clickedAdd: boolean = false;
  data
  xeppoGroupCode: any;
  xeppoCode: any;
  clientCode: any;
  userGroupList;
  isLoaded2:boolean;
  isLoaded3:boolean;
  searchStr;
  searchResults: UserGroupAddModel[] = [];
  searchText:string = '';
  isShowRecipient:boolean = false;
  fdsRecipientsList = [];
  accessToken: string ='';
  fileRequired:boolean = true;
  templateIdRequired:boolean = true;
  expireDateRequired:boolean = true;
  
  public iframeUrl: any;
  public loading: boolean;
  public invalid: any;
  public invalidEmail: boolean;
  public invalidRecepientEmail: boolean;

  public fdsRecipientsOldList: fdsOldRecipients[];
  public edit: boolean;
  public fdsServiceOldDocuments: fdsServiceOldDocuments[];
  public fdsServiceAgreementUpdateRequestData: any = {};
  public fdsId: string;
  public surName: string;

  constructor(
    private ngxService: NgxUiLoaderService, 
    private toastr: ToastrService,
    private fileUploadService: FileUploadService, 
    public modalRef: BsModalRef,
    private serviceAgreementService: ServiceAgreementService,
    private cookieService: CookieService,
  ) { 
    const current = new Date();
    this.minDate = {
      year: current.getFullYear(),
      month: current.getMonth() + 1,
      day: current.getDate()
    };
  }
  
  ngOnInit(): void {
    this.iframeUrl = this.data.url
    if (!this.iframeUrl) {
      this.getDSToken();
    }
    if(this.data.xeppoGroupCode !=null){
      this.xeppoGroupCode = this.data.xeppoGroupCode;
      this.xeppoCode = this.data.xeppoCode;
      this.clientCode = this.data.clientCode;
      this.surName = this.data.surName;
    }
    
    this.Isvalid = true;
    this.acceptDocType = ".pdf,.doc,.docx";  // ".pdf,.doc,.docx"
    this.companyCode = this.cookieService.get('companyCode');
    this.templateList = [{"id":"1","value":"Template 01"},{"id":"2","value":"Template 02"},{"id":"3","value":"Template 03"},{"id":"4","value":"Template 04"},{"id":"5","value":"Template 05"}]; 
    
    this.serviceAgreementModel = new ServiceAgreementAddModel();
    this.fdsServiceAgreementAddModel = new fdsServiceAgreementAddModel();
    this.fdsServiceDocuments = new fdsServiceDocuments();
    this.fdsServiceDocumentsAdd = new fdsServiceDocumentsAdd();
    this.fdsRecipients = new fdsRecipients();
    this.fdsServiceDocumentsAdd.templateId = "000";

    // Upload file globale value Start ------
    this.serviceAgreementModel.fdsServiceDocuments = [];

    //default template
    const now = new Date();
    const today = moment(now).format('MM-YYYY');
    this.fdsServiceAgreementAddModel.title = this.surName + '- Fee Disclosure Statement '+ today;
    this.fdsServiceAgreementAddModel.description = 'Please find enclosed your Fee Disclosure Statement (FDS).\n\nReview and sign the provided form/s where indicated as soon as possible.'
    if (this.data && this.data.keyFirmContacts) {
      const contact = this.data.keyFirmContacts.filter(a => a.contactType === 'Client Adviser')[0]
      this.fdsServiceAgreementAddModel.advisorName = (contact || {}).name;
      this.fdsServiceAgreementAddModel.advisorEmail = (contact || {}).email;
    }
    this.fdsServiceAgreementAddModel.isAdvisor = 'false';

    this.documentsArray = [];
    this.fileUploadAddModel = new FileUploadAddModel();
    this.fileUploadAddModel.fileCategory = "5";
    this.fileUploadAddModel.fileType = "3"; // 3=PDF
    this.fileUploadAddModel.userId = this.cookieService.get('CurrentUserId'); //JSON.parse(localStorage.getItem('CurrentUserId'));
    // Upload file globale value End ------

    this.fdsServiceAgreementAddModel.isDocVisibleToClient = true;

    this.getUserGroupList();
    if(this.data.fdsServiceAgreementAddModel) {
      this.edit = true;
      this.fdsId= this.data.fdsServiceAgreementAddModel.id;
      this.fdsServiceAgreementAddModel.title = this.data.fdsServiceAgreementAddModel.title;
      this.fdsServiceAgreementAddModel.description = this.data.fdsServiceAgreementAddModel.description;
      this.fdsServiceAgreementAddModel.isAdvisor = this.data.fdsServiceAgreementAddModel.fdsRecipients[0].advisorEmail != '' ? 'true' : 'false';
      this.fdsServiceAgreementAddModel.advisorEmail = this.data.fdsServiceAgreementAddModel.fdsRecipients[0].advisorEmail; 
      this.fdsServiceAgreementAddModel.advisorName = this.data.fdsServiceAgreementAddModel.fdsRecipients[0].advisorName; 

      var date_1 = new Date(this.data.fdsServiceAgreementAddModel.expireDate);
      this.fdsServiceAgreementAddModel.expireDate= { "year": date_1.getFullYear(), "month": date_1.getMonth()+1, "day": date_1.getDate()+1 }

      this.fdsServiceOldDocuments = this.data.fdsServiceAgreementAddModel.fdsServiceDocuments;
      
      this.fdsRecipientsOldList = this.data.fdsServiceAgreementAddModel.fdsRecipients;
    }
  }

  onSubmit(form:NgForm){
    this.fdsServiceAgreementAddModel.xeppoCode = +this.xeppoCode;
    this.fdsServiceAgreementAddModel.xeppoGroupCode = +this.xeppoGroupCode;
    this.fdsServiceAgreementAddModel.clientCode = this.clientCode;
    this.fdsServiceAgreementAddModel.fdsAgreementStatus = 1;
    
    let title = this.fdsServiceAgreementAddModel.title;
    let description = this.fdsServiceAgreementAddModel.description;  
    let expireDate = this.fdsServiceAgreementAddModel.expireDate;
    let notArchivedOldDocs = [], notArchivedOldRecepients = [];

    if (this.edit) {
      //get not archived list for calc full array length
      notArchivedOldDocs = this.fdsServiceOldDocuments.filter(item => item.isArchived == false);
      notArchivedOldRecepients = this.fdsRecipientsOldList.filter(item => item.isArchived == false);
    }
    let documentsList = this.edit ? [...notArchivedOldDocs, ...this.serviceAgreementModel.fdsServiceDocuments] : this.serviceAgreementModel.fdsServiceDocuments;
    
    let recipientsList = this.edit ? [...notArchivedOldRecepients, ...this.fdsRecipientsList]: this.fdsRecipientsList;
    
    if(form.invalid || (title && title.trim()=="") || (description && description.trim()=="") || (expireDate && expireDate.length==0) || (documentsList && documentsList.length==0) || (recipientsList && recipientsList.length==0) || this.invalid || this.invalidEmail || this.invalidRecepientEmail) { 
    
      if(title && title.trim()==""){
        form.controls['title'].setErrors({'required': true});
      }
      if(description && description.trim()==""){
        form.controls['description'].setErrors({'required': true});
      }
      if(expireDate == null){
        form.controls['expireDate'].setErrors({'required': true});
        this.expireDateRequired = false
      }

      if(documentsList.length==0){
        this.IsvalidDocument = false;
      }

      if(recipientsList.length==0){
        this.IsvalidRecipient = false;
      }

      if(form.pristine){
      }
      this.Isvalid = false;
      // console.log(form.invalid);  
      //console.log(this.Isvalid);
    }
    
    else{ 
      this.expireDateRequired = true
      this.Isvalid = true;
      let date = this.msqlDateFormat(form.value.expireDate);
      let fullDate = date +' '+'00:00.0000000';
      var date_1 = new Date(fullDate);
      this.fdsServiceAgreementAddModel.expireDate= date_1.toISOString();
      
      this.serviceAgreementModel.fdsServiceAgreementAddModel = this.fdsServiceAgreementAddModel;
      if(this.edit) {
        this.fdsServiceAgreementUpdateRequestData.fdsServiceAgreementUpdateModel = {
          expireDate: this.fdsServiceAgreementAddModel.expireDate,
          title: this.fdsServiceAgreementAddModel.title,
          description: this.fdsServiceAgreementAddModel.description,
          fdsAgreementStatus: this.fdsServiceAgreementAddModel.fdsAgreementStatus,
          isDocVisibleToClient: this.fdsServiceAgreementAddModel.isDocVisibleToClient,
        };

        this.fdsServiceAgreementUpdateRequestData.fdsServiceDocuments = this.fdsServiceOldDocuments;
        this.fdsServiceAgreementUpdateRequestData.fdsServiceNewDocuments = this.serviceAgreementModel.fdsServiceDocuments;

        // this.fdsServiceAgreementUpdateRequestData.fdsNewRecipients = this.fdsRecipientsList,
        // this.fdsServiceAgreementUpdateRequestData.fdsRecipients = this.fdsRecipientsOldList;
        console.log("serviceAgreementModel ==", this.fdsServiceAgreementUpdateRequestData);
        this.editData(this.fdsServiceAgreementUpdateRequestData, this.fdsId);
      } else {
        console.log("serviceAgreementModel ==", this.serviceAgreementModel);
        this.addData();
      }

    }

  }

  modalRehide(){
    if (!this.modalRef) {
      return;
    } 
    this.modalRef.hide();
    this.modalRef = null;
  }
  
  ClosePopup(){
    this.modalRef.hide();
  }

  msqlDateFormat(inDate) {
    var month;
    var day;
    month = ("0" + (inDate.month)).slice(-2);
    day = ("0" + (inDate.day)).slice(-2);
    return inDate.year + '-' + month + '-' + day;
  }

  editData(fdsServiceAgreementUpdateRequestData, fdsId) {
    // this.ngxService.start();
    // this.loading = true;
    this.serviceAgreementService.editServiceAgreement(fdsServiceAgreementUpdateRequestData, fdsId).subscribe((data:ServiceAgreementResponseProfile)=>{  
      if(data.error && !data.success){
        var date_1 = new Date(this.fdsServiceAgreementAddModel.expireDate);
        this.fdsServiceAgreementAddModel.expireDate= { "year": date_1.getFullYear(), "month": date_1.getMonth()+1, "day": date_1.getDate() }
    
        if(data.error.message) {
          this.toastr.error(data.error.message);
        } else {
          this.toastr.error('Error on saving Fee Disclosure Statement.');
        }
      }
      else{
        this.toastr.success('Fee Disclosure Statement updated successfully.');
        this.event.emit('OK');
      }
      this.modalRef.hide();
      // this.ngxService.stop();
      // this.loading = false;
    },err=>{
      // this.loading = false;
      // this.ngxService.stop();
      this.modalRef.hide();
      this.toastr.error('Error on Fee Disclosure Statement.');
    });
  }

  addData() {
    this.ngxService.start();
    this.loading = true;
    this.serviceAgreementService.addServiceAgreement(this.serviceAgreementModel, this.companyCode).subscribe((data:ServiceAgreementResponseProfile)=>{  
      if(data.error && !data.success){
        var date_1 = new Date(this.fdsServiceAgreementAddModel.expireDate);
        this.fdsServiceAgreementAddModel.expireDate= { "year": date_1.getFullYear(), "month": date_1.getMonth()+1, "day": date_1.getDate() }
        this.loading = false;
        this.ngxService.stop();
        if(data.error.message) {
          this.toastr.error(data.error.message);
        } else {
          this.toastr.error('Error on saving Fee Disclosure Statement.');
        }
      }
      else{
        this.serviceAgreementService.getEnvelopEditUrl(data.response.id, data.response.envelopeID).subscribe((res: any) => {
          if(res.success) {
            this.iframeUrl = res.response
            sessionStorage.setItem('serviceAgreementId', data.response.id)
          } else {
            this.modalRef.hide();
          }
          this.loading = false;
          this.ngxService.stop();
        }, err => {
          this.loading = false;
          this.ngxService.stop();
        })
        this.toastr.success('Fee Disclosure Statement added successfully.');
        this.event.emit('OK');
        // this.event.emit(this.gridViewStatus);
      }      
    },err=>{
      this.loading = false;
      this.ngxService.stop();
      this.toastr.error('Error on Fee Disclosure Statement.');
    });
  }

  onTemplaChange(){
    this.templateIdRequired = true
  }

  onFileChange(event){
    if(event.target.files[0]){
      this.fileUploadAddModel.file = <File>event.target.files[0];
      this.documentLabel = event.target.files[0].name;
      this.fileData = event.target;
    } 
    else{
      this.documentLabel = "Choose file";
    }
    this.IsvalidDocument = true;
    this.fileRequired = true
  }

  fileUpload() {
    console.log('fileData 333== ', this.fileData)
    console.log('fdsServiceDocumentsAdd.templateId 333== ', this.fdsServiceDocumentsAdd.templateId)
    if(this.fileData == "") {
      this.fileRequired = false
    } 
    if(this.fdsServiceDocumentsAdd.templateId == "000") {
      this.templateIdRequired = false
    } 
    // if(this.fileData != "" && this.fdsServiceDocumentsAdd.templateId != "000"){
    if(this.fileData != ""){
      this.clickedAdd = true;
      this.fileUploadService.uploadFileFDS(this.fileUploadAddModel).subscribe((data:FileUploadResponse)=>{ 
          
        if(data.error && !data.success){
          this.ngxService.stop();         
          this.errors = Utility.GetLocalErrorString(data.error.errorCode);
          //console.log(this.errors);
        }
        else{
          this.fdsServiceDocumentsAdd.documentName = this.fileData.files[0].name;
          let fileSize = this.fileData.files[0].size/1024/1024;
          this.fdsServiceDocumentsAdd.fileSize = fileSize.toFixed(2) + ' MB';
          
          let templateName = this.templateList.find(x => x.templateId ===  this.fdsServiceDocumentsAdd.templateId);
          
          let objectArray = {"documentName":this.fdsServiceDocumentsAdd.documentName,
                            // "templateName":templateName.name,
                            // "templateId":this.fdsServiceDocumentsAdd.templateId,
                            "s3Link":data.response.s3Key,
                            "fileSize":this.fdsServiceDocumentsAdd.fileSize};
          this.documentsArray.push(objectArray);

          this.serviceAgreementModel.fdsServiceDocuments = this.documentsArray;
          this.clickedAdd = false;
          this.documentLabel = "Choose file";
          // this.fdsServiceDocumentsAdd.templateId = "000";
          this.fdsServiceDocumentsAdd.document = null;
          this.fileData = "";
          // this.docUploadSuccess = true;
          // this.addData();
        }
      },err=>{ 
        this.clickedAdd = false;
        this.ngxService.stop();  
        this.toastr.error('Document upload error.');
      });
    }
    this.IsvalidDocument = true;
  }

  deleteFile(id, serviceDocument, ifOldFile?) {
    if(ifOldFile) {
      // this.fdsServiceOldDocuments.splice(id,1);
      this.fdsServiceOldDocuments.find(item => item.id == serviceDocument.id).isArchived = true;

    } else {
      this.serviceAgreementModel.fdsServiceDocuments.splice(id,1);
    }
  }

  getUserGroupList() {
    this.serviceAgreementService.getUserGroupList(this.xeppoGroupCode, this.companyCode).subscribe((data:UserGroupResponse)=>{
      this.userGroupList = data.response;
      this.isLoaded2 = true;
      },
    (err: HttpErrorResponse)=>{
      //console.log("Error"+ err.message);
    });
  }

  searchClients(searchText){  
    this.searchText = searchText;
    this.isShowRecipient = true;
    this.IsvalidRecipient = true;
    if(searchText.length > 2){
      let templateName = this.userGroupList.filter(x => x.name.toLowerCase().includes(searchText.toLowerCase()));
      this.searchResults = templateName;
    }     
  }

  addRecipients(recipient) {
    this.isShowRecipient = false;
    let objectArrayRecipients = {"xeppoCode":recipient.xeppoCode,
                                "xeppoGroupCode": +this.xeppoGroupCode,
                                "clientCode":recipient.clientCode,
                                "userId":recipient.id,
                                "email":recipient.email,
                                "isMobileUser":true,
                                "name":recipient.name,
                                "advisorName":'',
                                "advisorEmail":'',
                                "isSigned": false,
                              };
    // this.fdsRecipients.xeppoCode = recipient.xeppoCode;
    // this.fdsRecipients.xeppoGroupCode = this.xeppoGroupCode;
    // this.fdsRecipients.clientCode = recipient.clientCode;
    // this.fdsRecipients.userId = recipient.id;
    // this.fdsRecipients.email = recipient.email;
    // this.fdsRecipients.isMobileUser = recipient.isMobileUser;
    // this.fdsRecipients.name = recipient.userName;

    var isPresent = this.fdsRecipientsList.some(function(el){ return el.userId === recipient.id});
    
    if(recipient && !isPresent){
        const isPresentinOldList = (this.fdsRecipientsOldList && this.fdsRecipientsOldList.length > 0) ? this.fdsRecipientsOldList.some(function(el){ return el.userId === recipient.id}): false;
        if(!isPresentinOldList) {
          this.fdsRecipientsList.push(objectArrayRecipients);
          this.searchStr = '';
          this.serviceAgreementModel.fdsRecipients = this.fdsRecipientsList;
          // console.log('=vvvvvvvv this.fdsRecipientsList=', this.serviceAgreementModel.fdsRecipients)
          this.addAdvisorName();
          this.addAdvisorEmail()
        } else {
          this.toastr.error('Recipient already exists.');
        }     
    }
    if(isPresent) {
      this.toastr.error('Recipient already exists.');
    }
  }

  deleteRecipient(id, recipientId, isOld?) {
    if(isOld) {
      // this.fdsRecipientsOldList.splice(id,1);
      this.fdsRecipientsOldList.find(item => item.id == recipientId).isArchived = true;
    } else {
      this.fdsRecipientsList.splice(id,1);
    }
  }

  getDSToken() {
    this.serviceAgreementService.getDSToken().subscribe((data:any)=>{
      this.accessToken = data.response.accessToken;
      if(this.accessToken) {
        this.getDSGetTemplates(this.accessToken);
      }
    },
    (err: HttpErrorResponse)=>{
      //console.log("Error"+ err.message);
    });
  }

  getDSGetTemplates(accessToken) {
    this.serviceAgreementService.getDSGetTemplates(accessToken).subscribe((data:any)=>{
      this.templateList = data.response.templateIds;
      this.isLoaded3 = true;
      },
    (err: HttpErrorResponse)=>{
      //console.log("Error"+ err.message);
    });
  }

  expireDate(){
    this.expireDateRequired = true
  }

  // -- Update Table If Newtworth Value Chnaged -- //
  updateRecipientsEmail(object: any, isOldData?) {
    if(!isOldData) {
      // console.log('=vvvvvvvv =', object)

      this.fdsRecipientsList.find(item => item.userId == object.recipientsId).email = object.email;
      // this.fdsRecipientsList.map((todo, i) => {
      //   if (todo.userId == object.recipientsId){
      //      this.fdsRecipientsList[i] = object.email;
      //    }
      //  });
      this.serviceAgreementModel.fdsRecipients = this.fdsRecipientsList;
      // console.log('=vvvvvvvv22 this.fdsRecipientsList=', this.serviceAgreementModel.fdsRecipients)    
    } else {
      this.fdsRecipientsOldList.find(item => item.userId == object.recipientsId).email = object.email;
    }
  }

  addAdvisorEmail() {
    if(this.fdsServiceAgreementAddModel.isAdvisor === 'true' && this.serviceAgreementModel.fdsRecipients && this.serviceAgreementModel.fdsRecipients.length > 0) {
      this.serviceAgreementModel.fdsRecipients[0].advisorEmail = (this.fdsServiceAgreementAddModel || {}).advisorEmail;
      this.serviceAgreementModel.fdsRecipients[0].advisorName = (this.fdsServiceAgreementAddModel || {}).advisorName ? (this.fdsServiceAgreementAddModel || {}).advisorName : '';
    }
  }

  addAdvisorName() {
    if(this.fdsServiceAgreementAddModel.isAdvisor === 'true' &&this.serviceAgreementModel.fdsRecipients && this.serviceAgreementModel.fdsRecipients.length > 0) {
      this.serviceAgreementModel.fdsRecipients[0].advisorName = (this.fdsServiceAgreementAddModel || {}).advisorName;
      this.serviceAgreementModel.fdsRecipients[0].advisorEmail = (this.fdsServiceAgreementAddModel || {}).advisorEmail ? (this.fdsServiceAgreementAddModel || {}).advisorEmail : '';
    }
  }

  // -- Update Table If Newtworth Value Chnaged -- //
  updateAdvisorEmail(object: any) {
    // console.log('=vvvvvvvv =', object)
    const advisor = this.fdsRecipientsList.find(item => item.userId == object.recipientsId)
    advisor.advisorEmail = object.email;
    this.serviceAgreementModel.fdsRecipients = this.fdsRecipientsList;
    // console.log('=vvvvvvvv22 this.fdsRecipientsList=', this.serviceAgreementModel.fdsRecipients)
    this.invalid = advisor.advisorEmail && !advisor.advisorName ? true: false;
    const pattern =  new RegExp('^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$');
    this.invalidEmail = !pattern.test(advisor.advisorEmail);
  }
  // -- Update Table If Newtworth Value Chnaged -- //
  updateAdvisorName(object: any) {
    // console.log('=vvvvvvvv =', object)
    const advisor = this.fdsRecipientsList.find(item => item.userId == object.recipientsId)
    advisor.advisorName = object.email;
    this.serviceAgreementModel.fdsRecipients = this.fdsRecipientsList;
    // console.log('=vvvvvvvv22 this.fdsRecipientsList=', this.serviceAgreementModel.fdsRecipients)
    this.invalid = !advisor.advisorEmail && advisor.advisorName ? true: false;
  }

  setEmailValidity(event) {
    const pattern =  new RegExp('^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$');
    const hasInvalid = this.fdsRecipientsList.filter(a=> !pattern.test(a['email']) === true);
    if (hasInvalid.length > 0) {
      this.invalidRecepientEmail = true
    } else {
      this.invalidRecepientEmail = false
    }
    return !pattern.test(event);
  }
}
